<template>
  <v-alert v-model="isDisplayed"
           :border="noBorder ? null : 'start'"
           :closable="dismissible"
           :icon="noIcon ? false : icon"
           :type="type"
           :variant="variant"
           class="mb-0"
           v-bind="$attrs"
  >
    <!-- @slot for alert content -->
    <slot></slot>
    <template v-if="dismissible" #close>
      <AppButton class="ml-4"
                 color="black"
                 style="font-size: 16px;"
                 text
                 @click="closeAlert"
      >
        <font-awesome-icon :icon="['fal', 'xmark']"></font-awesome-icon>
      </AppButton>
    </template>
  </v-alert>
</template>

<script>
import AppButton from '../buttons/AppButton.vue'

const ALERT_TYPES = Object.freeze({
  info: 'info',
  warning: 'warning',
  error: 'error',
})
/**
 * Default Alert
 */
export default {
  name: 'Alert',
  components: {
    AppButton,
  },
  /*
  * All Vuetify props for Alert components are usable.
  * See doc : https://vuetifyjs.com/en/api/v-alert/#props
  */
  inheritAttrs: false,
  props: {
    /**
     * display state
     */
    value: {
      type: Boolean,
      default: undefined,
      validator: val => val === true || val === false || val === undefined,
    },
    /**
     * Designates a specific icon
     */
    icon: {
      type: [Boolean, String],
      default: 'fal fa-circle-info',
    },
    /**
     * Adds a close icon that can hide the alert
     */
    dismissible: {
      type: Boolean,
      default: true,
    },
    /**
     * Applies the defined color to text and a low opacity background of the same
     */
    text: {
      type: Boolean,
      default: false,
    },
    /**
     * Specify a success, info, warning or error alert. Uses the contextual color and has a pre-defined icon
     */
    type: {
      type: String,
      default: 'info',
      validator: value => {
        return value in ALERT_TYPES
      },
    },
    /**
     * Wether the left icon is displayed
     */
    noIcon: {
      type: Boolean,
      default: false,
    },
    /**
     * Wether the left border is displayed
     */
    noBorder: {
      type: Boolean,
      default: false,
    },
  },
  data () {
    return {
      internalVisible: true,
    }
  },
  computed: {
    isDisplayed: {
      get () {
        return this.value !== undefined ? this.value : this.internalVisible
      },
      set (val) {
        if (this.value !== undefined) {
          this.$emit('input', val)
        } else {
          this.internalVisible = val
        }
      },
    },
    variant () {
      return this.text ? 'text': 'tonal'
    },
  },
  methods: {
    closeAlert () {
      this.isDisplayed = false
    },
  },
}
</script>

<style scoped lang="scss">
  :deep(.v-alert__content) {
    color: #333;
  }
  :deep(.v-alert__prepend) {
    margin-inline-end: 8px;
}
</style>
